import React,{useEffect,useState} from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServicesPreview from './components/ServicesPreview';
import HowItWorks from './components/HowItWorks';
import AppPreview from './components/AppPreview';
import PricingPreview from './components/PricingPreview';
import ClosingCta from './components/ClosingCta';
import Footer from './components/Footer';
import MobileTabBar from './components/MobileTabBar';
import ServicesPage from './components/ServicesPage';
import PricingPage from './components/PricingPage';
import HowItWorksPage from './components/HowItWorksPage';
import BookPage from './components/BookPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import './App.css';
import './plans.css';
import './pages.css';

const SEO={
  default: {
    title: 'Handle My Tech | Done-for-you tech for local businesses',
    desc: 'Missed-call text-back, AI receptionist, online booking, reviews, invoicing and more, set up and run for local businesses in Surprise, AZ and beyond. Packages from $149/month.'
  },
  '#/services': {
    title: 'Services | Handle My Tech',
    desc: 'Missed-call text-back, AI chat and voice receptionist, booking and reminders, review management, invoicing, email and social posting, all done for you.'
  },
  '#/pricing': {
    title: 'Pricing | Handle My Tech',
    desc: 'Three packages from $149/month, or individual services from $99/month. No long-term contracts.'
  },
  '#/how-it-works': {
    title: 'How it works | Handle My Tech',
    desc: 'Book a free call, we set everything up, and we keep it running. See who does what.'
  },
  '#/book': {
    title: 'Book a call | Handle My Tech',
    desc: 'Book a free 30-minute call to find out what would help your business most.'
  },
  '#/privacy': {
    title: 'Privacy Policy | Handle My Tech',
    desc: 'How Handle My Tech collects, uses and protects your information, including text messaging.'
  },
  '#/terms': {
    title: 'Terms of Service | Handle My Tech',
    desc: 'The terms for using Handle My Tech services, including SMS terms.'
  }
};

function Site() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <Hero />
        <ServicesPreview />
        <HowItWorks />
        <AppPreview />
        <PricingPreview />
        <ClosingCta />
      </main>
      <Footer />
    </div>
  );
}

function Routes({hash}) {
  if (hash==='#/services') return <ServicesPage />;
  if (hash==='#/pricing') return <PricingPage />;
  if (hash==='#/how-it-works') return <HowItWorksPage />;
  if (hash==='#/book') return <BookPage />;
  if (hash==='#/privacy') return <PrivacyPage />;
  if (hash==='#/terms') return <TermsPage />;
  return <Site />;
}

function App() {
  const [hash,setHash]=useState(window.location.hash);

  useEffect(()=> {
    const onHash=()=> setHash(window.location.hash);
    window.addEventListener('hashchange',onHash);
    return ()=> window.removeEventListener('hashchange',onHash);
  },[]);

  useEffect(()=> {
    const seo=SEO[hash] || SEO.default;
    document.title=seo.title;
    const meta=document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content',seo.desc);
    if (hash==='' || hash.startsWith('#/')) {
      window.scrollTo(0,0);
      return;
    }
    setTimeout(()=> {
      const el=document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView();
    },50);
  },[hash]);

  return (
    <>
      <Routes hash={hash} />
      <MobileTabBar />
    </>
  );
}

export default App;
